import { useRef, useState } from 'react';

let shiftX = 0;
let shiftY = 0;
let mouseDowned = false;

function useDragAndDrop() {
  const [isMinimized, setIsMinimized] = useState(false);
  const refContainer = useRef(null);
  const updatePosition = (pageX, pageY) => {
    const ref = refContainer.current;
    const left = pageX - shiftX;
    const top = pageY - shiftY;
    ref.style.left = `${left}px`;
    ref.style.top = `${top}px`;
  };

  const resetPositionMinimized = fullscreen => {
    const ref = refContainer.current;
    ref.style.left = fullscreen ? '0px' : `12px`;
    ref.style.bottom = fullscreen ? 'unset' : `12px`;
    ref.style.top = fullscreen ? '0px' : `unset`;
  };

  const onMouseDown = event => {
    if (!isMinimized) return;
    mouseDowned = true;
    const ref = refContainer.current;
    shiftX = event.clientX - ref.getBoundingClientRect().left;
    shiftY = event.clientY - ref.getBoundingClientRect().top;
  };

  const onMouseMove = event => {
    if (mouseDowned && isMinimized) {
      updatePosition(event.pageX, event.pageY);
    }
  };

  const onMouseUp = () => {
    if (!isMinimized) return;
    mouseDowned = false;
  };

  const onMouseLeave = () => {
    if (!isMinimized) return;
    mouseDowned = false;
  };

  return {
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onMouseLeave,
    updatePosition,
    refContainer,
    resetPositionMinimized,
    setIsMinimized,
    isMinimized,
  };
}

export default useDragAndDrop;
